import React, { useState } from "react"
import propTypes from "prop-types"

const ConfigContext = React.createContext({})

export function withAnnotationsConfig(Component) {
  return function (props) {
    return (
      <ConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </ConfigContext.Consumer>
    )
  }
}

export default function AnnotationsConfigProvider(props) {
  // Variables related to creating new annotations
  const [showAnnotationLines, setShowAnnotationLines] = useState(false)
  const [xAxisValue, setXAxisValue] = useState(null)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [activeRun, setActiveRun] = useState(null)
  const [activeGraph, setActiveGraph] = useState(null)
  // --- Variables related to creating new annotations

  // Variables related to visibility of lines/text on annotations
  const [annotationVisibilityState, setAnnotationVisibilityState] = useState({})
  // --- Variables related to visibility of lines/text on annotations

  const toggleAnnotationsView = () => {
    setShowAnnotationLines(!showAnnotationLines)
  }

  const canAnnotateGraph = (graphKey) => {
    return !graphKey.special || ["microbial-community"].includes(graphKey.special)
  }

  const annotationClick = (x_val, graphKey, run_id) => {
    if (canAnnotateGraph(graphKey) && showAnnotationLines) {
      setXAxisValue(x_val)
      setShowCreateModal(true)
      setActiveRun(run_id)
      setActiveGraph(graphKey)
    }
  }

  const hideCreateAnnotationsModal = () => {
    setXAxisValue("")
    setShowCreateModal(false)
    setActiveRun(null)
    setActiveGraph(null)
  }

  const updateRunAnnotationState = (annotations) => {
    const annotation_visibility_state = annotationVisibilityState
    const new_annotations = {}
    annotations
      .filter((ano) => ![Object.keys(annotation_visibility_state)].includes(ano.id))
      .map((ano) => {
        new_annotations[ano.id] = {
          show_text: false,
          show_line: true,
        }
      })

    setAnnotationVisibilityState({
      ...annotation_visibility_state,
      ...new_annotations,
    })
  }

  const toggleAnnotationsFeature = (metric, ano_id) => {
    const annotation_visibility_state = annotationVisibilityState
    const single_anno_state = annotation_visibility_state[ano_id]

    setAnnotationVisibilityState({
      ...annotation_visibility_state,
      [ano_id]: {
        ...single_anno_state,
        [metric]: !single_anno_state[metric],
      },
    })

    return single_anno_state[metric]
  }

  const toggleMultipleAnnotationsFeature = (events) => {
    const annotation_visibility_state = annotationVisibilityState
    const updated_annotations = {}
    events.forEach((ano_item) => {
      const single_anno_state = annotation_visibility_state[ano_item.id]

      updated_annotations[ano_item.id] = {
        ...single_anno_state,
        [ano_item.metric]: !single_anno_state[ano_item.metric],
      }
    })

    setAnnotationVisibilityState({
      ...annotation_visibility_state,
      ...updated_annotations,
    })
  }

  return (
    <ConfigContext.Provider
      value={{
        show_annotation_lines: showAnnotationLines,
        x_axis_value: xAxisValue,
        showCreateModal: showCreateModal,
        activeRun: activeRun,
        activeGraph: activeGraph,
        canAnnotateGraph: canAnnotateGraph,
        toggleAnnotationsView: toggleAnnotationsView,
        annotation_click: annotationClick,
        hideCreateAnnotationsModal: hideCreateAnnotationsModal,

        updateRunAnnotationState: updateRunAnnotationState,
        toggleAnnotationsFeature: toggleAnnotationsFeature,
        toggleMultipleAnnotationsFeature: toggleMultipleAnnotationsFeature,
        annotation_visibility_state: annotationVisibilityState,
      }}
    >
      {props.children}
    </ConfigContext.Provider>
  )
}

AnnotationsConfigProvider.propTypes = {
  children: propTypes.node.isRequired,
}
